module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8644/img/spinner.png"